import {
  Add,
  FilterListOutlined,
  FilterTiltShiftOutlined,
  HubOutlined,
  ViewHeadlineOutlined,
} from '@mui/icons-material';
import { Divider, List } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { Restricted } from '@procureai/permissions-ui';
import { NavCollapse, NavDrawerProps } from '@procureai/ui-mui';
import { Trans } from 'react-i18next';
import { useMatch } from 'react-router-dom';

import { AstroSmartLinkDomain } from '@/generated/gql/graphql';
import { NavId, RuleDomainType, FeatureFlag } from '~/common/types';
import { FiltersNavList } from '~/components/FiltersNavList/FiltersNavList';
import { NavDrawerSimple } from '~/components/NavDrawerSimple/NavDrawerSimple';
import { NavSubListItemLink } from '~/components/NavSubListItemLink/NavSubListItemLink';
import { SmartLinksEditDialog } from '~/components/SmartLinksEditDialog/SmartLinksEditDialog';
import { SmartLinksNavList } from '~/components/SmartLinksNavList/SmartLinksNavList';
import { RouteId } from '~/routes/RouteId';

export const SettingsDrawer = (props: NavDrawerProps) => {
  return (
    <NavDrawerSimple navId={NavId.settings} {...props}>
      <Restricted needs={{ permission: Permission.RuleList }}>
        <NavCollapse
          in
          icon={<FilterTiltShiftOutlined />}
          label={<Trans i18nKey="Nav.settingsFilterTitle" />}
          sx={{ marginBottom: 4 }}
        >
          <List>
            <NavSubListItemLink
              id={NavId.settingsAllRules}
              to={RouteId.ruleList}
              selected={!!useMatch({ path: RouteId.ruleList, end: true })}
              Icon={ViewHeadlineOutlined}
            />
            <FiltersNavList domain={RuleDomainType.RULE_SOURCING} Icon={FilterListOutlined} showDot />
          </List>
        </NavCollapse>
        <Divider />
        <NavCollapse
          in
          icon={<Add />}
          label={<Trans i18nKey={`Nav.${NavId.settingsRuleAdd}`} />}
          sx={{ marginBottom: 4 }}
        >
          <List>
            <NavSubListItemLink
              id={NavId.settingsRuleCreate}
              to={RouteId.ruleCreate}
              Icon={FilterTiltShiftOutlined}
              needs={{ permission: Permission.RuleEdit }}
            />
          </List>
        </NavCollapse>
      </Restricted>

      <Restricted needs={{ permission: Permission.KnowledgeList }}>
        <Divider />
        <NavCollapse
          in
          icon={<HubOutlined />}
          label={<Trans i18nKey={`Nav.knowledgeRepository`} />}
          sx={{ marginBottom: 4 }}
        >
          <List>
            <NavSubListItemLink
              id={NavId.settingsProcurementKnowledge}
              to={RouteId.knowledgeRepository}
              needs={{ permission: Permission.KnowledgeList }}
            />
          </List>
        </NavCollapse>
      </Restricted>
      <Divider />

      <Divider />
      <Restricted needs={{ feature: FeatureFlag.SMART_LINKS }}>
        <SmartLinksNavList
          domain={AstroSmartLinkDomain.SETTINGS}
          label={<Trans i18nKey="Nav.settingsAdditionalSettings" />}
        >
          <SmartLinksEditDialog
            domain={AstroSmartLinkDomain.SETTINGS}
            label="settingsManageLinks"
            dialogTitle="settingsManageLinks"
          />
        </SmartLinksNavList>
      </Restricted>
    </NavDrawerSimple>
  );
};
